import React from "react";
import { Column, Row } from "simple-flexbox";
import { StyleSheet, css } from "aphrodite";
import LogoComponent from "./LogoComponent";
import { getUser } from "../../helpers/user";
import IconBurger from "../../assets/icon-burger";
import SidebarMenu from "./SidebarMenu";

class SidebarComponent extends React.Component {
  state = { expanded: false };

  onItemClicked = (item) => {
    this.props.onChange(item);
  };

  isMobile = () => window.innerWidth <= 768;

  toggleMenu = () =>
    this.setState((prevState) => ({ expanded: !prevState.expanded }));

  renderBurger = () => {
    return (
      <div onClick={this.toggleMenu} className={css(styles.burgerIcon)}>
        <IconBurger />
      </div>
    );
  };

  render() {
    const { expanded } = this.state;
    const isMobile = this.isMobile();
    let role = null;
    const user = getUser();
    if (user) {
      role = user.role_codes[0];
    }

    const isPaidDues =
      role === "member" && user?.member_profile?.is_paid_dues === 1;

    return (
      <div className={css(styles.root)}>
        <Row
          className={css(styles.mainContainer)}
          breakpoints={{ 768: css(styles.mainContainerMobile) }}
        >
          {isMobile && !expanded && this.renderBurger()}
          <Column
            className={css(styles.container)}
            breakpoints={{
              768: css(
                styles.containerMobile,
                expanded ? styles.show : styles.hide
              ),
            }}
          >
            <LogoComponent />
            <SidebarMenu
              role={role}
              isPaidDues={isPaidDues}
              selectedItem={this.props.selectedItem}
              onItemClicked={this.onItemClicked}
              styles={styles}
            />
          </Column>
          {isMobile && expanded && (
            <div
              className={css(styles.outsideLayer)}
              onClick={this.toggleMenu}
            />
          )}
        </Row>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  root: {
    position: "relative",
    width: 220,
    minWidth: 220,
    height: "100%",
    zIndex: 2,
  },
  burgerIcon: {
    cursor: "pointer",
    position: "absolute",
    left: 24,
    top: 34,
  },
  container: {
    width: 220,
    paddingTop: 32,
    height: "calc(100% - 32px)",
  },
  containerMobile: {
    transition: "left 0.5s, right 0.5s",
    position: "absolute",
    width: 220,
    height: "100%",
    zIndex: 901,
  },
  mainContainer: {
    width: 220,
    height: "100%",
    minHeight: "100vh",
    backgroundColor: "#31BC69",
  },
  mainContainerMobile: {
    backgroundColor: "transparent",
    position: "absolute",
    minWidth: "100%",
    top: 0,
    left: 0,
  },
  menuItemList: {
    marginTop: 52,
  },
  outsideLayer: {
    position: "absolute",
    width: "100vw",
    minWidth: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,.50)",
    zIndex: 900,
  },
  hide: {
    left: -220,
    backgroundColor: "#31BC69",
  },
  show: {
    left: 0,
    backgroundColor: "#31BC69",
  },
  navlink: {
    textDecoration: "none",
  },
});

export default SidebarComponent;
